// extracted by mini-css-extract-plugin
module.exports = {"label":"Switch_label__JuE_I","checked":"Switch_checked__1cpf2","disabled":"Switch_disabled__1S9zw","switch":"Switch_switch__1eVR2","thumb":"Switch_thumb__1ybex"};